import React from 'react';
import { Check, X } from 'lucide-react';

const Cell = ({ value }) => {
  if (value === 'yes') {
    return (
      <div className="flex justify-center">
        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-emerald-100 text-emerald-700">
          <Check className="w-4 h-4" strokeWidth={3} />
        </span>
      </div>
    );
  }
  if (value === 'no') {
    return (
      <div className="flex justify-center text-slate-300">
        <X className="w-5 h-5" strokeWidth={2} />
      </div>
    );
  }
  return <span className="text-sm text-slate-700 text-center block">{value}</span>;
};

const CompareTable = ({ groups }) => (
  <div className="hidden lg:block bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-testid="compare-table">
    <div className="sticky top-0 z-10 grid grid-cols-12 bg-slate-900 text-white px-6 py-4">
      <div className="col-span-6 text-sm font-semibold uppercase tracking-wide text-slate-300">Feature</div>
      <div className="col-span-3 text-center text-sm font-semibold uppercase tracking-wide text-teal-300">Continuity Tier</div>
      <div className="col-span-3 text-center text-sm font-semibold uppercase tracking-wide text-emerald-300">Clarity Tier</div>
    </div>
    {groups.map((group) => (
      <div key={group.title}>
        <div className="grid grid-cols-12 bg-slate-50 border-t border-b border-slate-200 px-6 py-3">
          <div className="col-span-12 font-serif text-lg text-slate-900">
            {group.title}
            {group.note && <span className="ml-2 text-sm font-sans text-slate-500 font-normal">{group.note}</span>}
          </div>
        </div>
        {group.rows.map((row) => (
          <div key={row.feature} className="grid grid-cols-12 items-center px-6 py-3 border-b border-slate-100 hover:bg-slate-50/50">
            <div className="col-span-6 text-sm text-slate-800">{row.feature}</div>
            <div className="col-span-3"><Cell value={row.continuity} /></div>
            <div className="col-span-3"><Cell value={row.premium} /></div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default CompareTable;
